/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ApiError from '../model/ApiError';
import ProductCode from '../model/ProductCode';
import SuccessResponse from '../model/SuccessResponse';

/**
* ProductCodes service.
* @module api/ProductCodesApi
* @version V1
*/
export default class ProductCodesApi {

    /**
    * Constructs a new ProductCodesApi. 
    * @alias module:api/ProductCodesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getAllRedeemedProductCodesOnAccount operation.
     * @callback module:api/ProductCodesApi~getAllRedeemedProductCodesOnAccountCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ProductCode>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ProductCodesApi~getAllRedeemedProductCodesOnAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ProductCode>}
     */
    getAllRedeemedProductCodesOnAccount(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [ProductCode];
      return this.apiClient.callApi(
        '/product-codes/redeemed', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the redeemNewProductCode operation.
     * @callback module:api/ProductCodesApi~redeemNewProductCodeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SuccessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} productCode 
     * @param {module:api/ProductCodesApi~redeemNewProductCodeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SuccessResponse}
     */
    redeemNewProductCode(productCode, callback) {
      let postBody = null;
      // verify the required parameter 'productCode' is set
      if (productCode === undefined || productCode === null) {
        throw new Error("Missing the required parameter 'productCode' when calling redeemNewProductCode");
      }

      let pathParams = {
        'productCode': productCode
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SuccessResponse;
      return this.apiClient.callApi(
        '/product-codes/redeem/{productCode}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
